import React, { useCallback } from 'react';
import { QuickCreateModal } from 'simple-creator';
import { useApi } from 'react-ui';
import { useCreatorModal } from '../contexts/CreatorModal';

/**
 * Handles the QuickCreateModal rendering.
 * Refresh/open logic is handled by BalloonEventNotifier listeners
 * in EventDataProvider and BalloonEventsMapBox.
 */
export const CreatorModalHandler: React.FC = () => {
  const { apiEndpoints, apiKey } = useApi();
  const { isOpen, geoLocation, editIdentifier, editEvent, cloneEvent, isEditMode, closeCreator } = useCreatorModal();

  const handleSuccess = useCallback(() => {
    console.log('[CreatorModalHandler] handleSuccess — closing modal (refresh handled by BalloonEventNotifier)');
    closeCreator();
  }, [closeCreator]);

  if (!isOpen) return null;

  return (
    <QuickCreateModal
      isOpen={isOpen}
      geoLocation={isEditMode ? undefined : geoLocation}
      editIdentifier={editIdentifier}
      editEvent={editEvent}
      cloneEvent={cloneEvent}
      onClose={closeCreator}
      onSuccess={handleSuccess}
      apiEndpoint={apiEndpoints.metadata.replace('/api/metadata', '')}
      apiKey={apiKey}
    />
  );
};
